import React, { useState, useMemo } from 'react';
import { Box } from '@mui/material';
import { 
  DataGrid, 
  DataGridProps, 
  GridColDef, 
  GridEditInputCell 
} from '@mui/x-data-grid';

interface EditableDataGridProps extends DataGridProps {
  columns: GridColDef[];
}

export const EditableDataGrid: React.FC<EditableDataGridProps> = ({ 
  columns: baseColumns, 
  ...props 
}) => {
  const [isGridEditing, setIsGridEditing] = useState(false);

  // Автоматически внедряем автовыделение текста во все числовые редактируемые колонки
  const enhancedColumns = useMemo(() => {
    return baseColumns.map((col) => {
      if (col.type === 'number' && col.editable) {
        return {
          ...col,
          valueParser: (value: any) => Number(value),
          renderEditCell: (params: any) => (
            <GridEditInputCell
              {...params}
              inputProps={{
                onFocus: (event: React.FocusEvent<HTMLInputElement>) => {
                  event.target.select(); // Выделяем текст при фокусе (Enter / DoubleClick)
                },
              }}
            />
          ),
        };
      }
      return col;
    });
  }, [baseColumns]);

  return (
    <Box
      // Перехватываем Escape на уровне контейнера грида
      onKeyDown={(event) => {
        if (event.key === 'Escape' && isGridEditing) {
          // Если грид в режиме редактирования, тушим событие, чтобы оно не долетело до Dialog
          event.stopPropagation();
        }
      }}
      sx={{ width: '100%', height: '100%' }}
    >
      <DataGrid
        {...props}
        columns={enhancedColumns}
        editMode="row" // Фиксируем режим редактирования строк
        // Добавлен третий аргумент details, чтобы TS не ругался в старых версиях
        onRowEditStart={(params, event, details) => {
          setIsGridEditing(true);
          props.onRowEditStart?.(params, event, details);
        }}
        onRowEditStop={(params, event, details) => {
          // Небольшой таймаут, чтобы фаза всплытия Escape успела завершиться до сброса флага
          setTimeout(() => setIsGridEditing(false), 100);
          props.onRowEditStop?.(params, event, details);
        }}
      />
    </Box>
  );
};